module.exports = __webpack_public_path__ + "img/Table_view_blue.67019080.svg";